import {
    Trash2
} from 'lucide-react';

export function ImagePreviewCard({
    item, index, onRemove
}) {
    return (
        <div
            key={index}
            className="group relative flex flex-col items-center border border-gray-200 rounded-md p-2 bg-white shadow-sm hover:shadow-md transition-shadow"
            style={{
                maxWidth: '100px'
            }}
        >
            {/* Image Preview */}
            <a
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className="relative block w-full"
            >
                <img
                    src={item.url}
                    alt={item.name}
                    className="w-full h-20 object-contain rounded"
                    onError={(e) => {
                        e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIGZpbGw9IiNGM0Y0RjYiLz48cGF0aCBkPSJNMjQgMjRIMzJWMzJIMjRWMjRaTTI0IDMySDMyVjQwSDI0VjMyWk0zMiAyNEg0MFYzMkgzMlYyNFpNMzIgMzJINDBWNDBIMzJWMzJaIiBmaWxsPSIjOUM5Q0EzIi8+PC9zdmc+';
                        e.target.classList.add('opacity-50');
                    }}
                />
                {/* Delete Overlay on Hover */}
                <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center rounded">
                    <button
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            onRemove(index);
                        }}
                        className="text-white hover:text-red-400 transition-colors"
                    >
                        <Trash2 size={20}/>
                    </button>
                </div>
            </a>
            {/* Image Name */}
            <a
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-xs cursor-pointer hover:underline text-center mt-1 w-full truncate"
                title={item.name}
            >
                {item.name}
            </a>
        </div>
    );
}
